/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it 😉",
  'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
  'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
  'embedded.confluence.footer.hover.text': 'View in Confluence',
  'embedded.confluence.footer.prefix': 'Powered by',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
  'embedded.confluence.login-page.login-button': 'Log in to Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
  'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
  'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
  'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
  'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
  'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
  'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};